import { BILLING_UPGRADE_PATH } from '../constants/urls';

/**
 * Validates a post-upgrade return target: same-origin path + optional query only.
 * Used with `return` query param on `/billing/upgrade` to avoid open redirects.
 */
export function parseSafeAppReturnPath(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  let s = raw.trim();
  if (!s) return null;
  try {
    s = decodeURIComponent(s);
  } catch {
    return null;
  }
  s = s.trim();
  if (!s) return null;
  if (!s.startsWith('/')) return null;
  if (s.startsWith('//')) return null;
  if (s.includes('\\')) return null;
  if (s.includes('\0')) return null;
  if (/[\n\r]/.test(s)) return null;

  const q = s.indexOf('?');
  const path = q === -1 ? s : s.slice(0, q);
  const search = q === -1 ? '' : s.slice(q);
  if (path.includes('//')) return null;
  // Reject scheme-like first segment (e.g. /javascript:..., /https:...)
  if (/^\/[^/]*:/i.test(path)) return null;

  return path + search;
}

export function buildBillingUpgradeUrl(params: {
  returnPath?: string | null;
  source?: string;
}): string {
  const sp = new URLSearchParams();
  if (params.returnPath) {
    sp.set('return', params.returnPath);
  }
  if (params.source) {
    sp.set('source', params.source);
  }
  const qs = sp.toString();
  return qs ? `${BILLING_UPGRADE_PATH}?${qs}` : BILLING_UPGRADE_PATH;
}
